import React from 'react'
import CustomButton from './CustomButton'

const HeadingBox = ({subtitle, title, desc, button, classN, subtitleText, btnLink}) => {
  return (
    <div className="flex flex-col gap-4">
            <h6 className={`lg:text-sm text-xs ${subtitleText}`}>{subtitle}</h6>
            <h2 className={`lg:max-w-[622px] max-w-[1000%] lg:text-5xl text-xl font-semibold ${classN}`}>{title}</h2>
            <p className="lg:text-base text-sm lg:max-w-[622px] max-w-[100%]">{desc}</p>
            {
                button && <CustomButton title={button} routeLink={btnLink} />
            }
    </div>
  )
}

export default HeadingBox